import type { EdgeRef } from '../commandBuilders.js';
import type { AppState } from '../../state/appState.js';
import type { GraphEdge } from '../../graph/nodeDefs.js';

export function sameEdge(a: EdgeRef, b: EdgeRef): boolean {
  return a.fromNode === b.fromNode
    && a.fromPort === b.fromPort
    && a.toNode === b.toNode
    && a.toPort === b.toPort;
}

export function edgeExistsFor(appState: AppState, edge: EdgeRef): boolean {
  return appState.edges.some(candidate => sameEdge(candidate, edge));
}

export function findIncomingEdgeFor(appState: AppState, toNode: string, toPort: number): GraphEdge | null {
  return appState.edges.find(edge => edge.toNode === toNode && edge.toPort === toPort) ?? null;
}

export function removeEdgeFor(appState: AppState, edge: EdgeRef): boolean {
  const nextEdges = appState.edges.filter(candidate => !sameEdge(candidate, edge));
  if (nextEdges.length === appState.edges.length) return false;
  appState.edges = nextEdges;
  return true;
}

export function addEdgeFor(appState: AppState, edge: EdgeRef): boolean {
  if (edgeExistsFor(appState, edge)) return false;
  appState.edges = [...appState.edges, { ...edge }];
  return true;
}

export function nodeTypeByIdFor(appState: AppState, id: string): string {
  return appState.nodes.find(n => n.id === id)?.type ?? id;
}
